import { LitElement, html, svg } from 'lit';

export class IconGrid16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Fire kvadrater som danner et større kvadrat</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 1H1v5h5V1ZM6 10H1v5h5v-5ZM15 1h-5v5h5V1ZM15 10h-5v5h5v-5Z"></path></svg>`; }
}
if (!customElements.get('f-icon-grid16', IconGrid16)) {
  customElements.define('f-icon-grid16', IconGrid16);
}